const yearsForCountryTitle = (): string => {
  const today = new Date();
  const currentMonth = today.getMonth();
  const currentDay = today.getDate();

  let currentYear = today.getFullYear();
  if (currentMonth >= 10 && currentDay >= 15) {
    currentYear += 1;
  }

  const nextYear = currentYear + 1;

  return `${currentYear}/${nextYear}`;
};

export default yearsForCountryTitle;
